`<template>
  <div class="uni-menu">
    <div class="uni-menu-box">
      <el-menu
        class="uni-menu-list"
        background-color="transparent"
        text-color="#fff"
        active-text-color="#fff"
        :default-openeds="defaultMenuIndex"
        menu-trigger="click"
        :collapse="isCollapse"
      >
        <el-menu-item index="1" style="text-align: right" @click="menuCollapse">
          <i
            class="iconfont iconcaidanshouqi2"
            style="color: #fff; font-size: 20px"
          ></i>
        </el-menu-item>
        <!-- <el-menu-item
          index="home"
          @click="jumpHome"
          v-if="userInfo.user_type != 'teacher'"
        >
          <i class="iconfont iconyemian-copy-copy-copy"></i>
          <span slot="title">首页</span>
        </el-menu-item> -->

        <div
          :class="{'isShowIconArrow': isCollapse}"
          v-for="item in menuLists"
          :key="item.meta.title"
        >
          <el-submenu 
            :index="item.meta.title"
            v-if="!item.alwaysShow"
          >
            <template slot="title">
              <i class="iconfont" :class="item.meta.icon"></i>
              <span v-if="!isCollapse">{{ item.meta.title }}</span>
            </template>

            <div class="uni-menu-group">
              <div class="uni-submenu">
                <div class="uni-submenu-list">
                  <div
                    v-for="child in item.children"
                    class="link"
                    :class="menuActive == child.meta.title ? 'active' : ''"
                    @click="jump(child)"
                    :key="child.meta.title"
                  >
                    <span>{{ child.meta.title }}</span>
                  </div>
                  <div v-if="item.children && item.children.length == 0">
                    <span>暂无练习</span>
                  </div>
                </div>
              </div>
            </div>
          </el-submenu>
          <div v-else>
            <el-menu-item
              v-for="child in item.children"
              class="link"
              :class="menuActive == child.meta.title ? 'active' : ''"
              @click="jump(child)"
              :key="child.meta.title"
              :index="child.meta.title"
            >
              <i class="iconfont" :class="item.meta.icon"></i>
              <span slot="title">{{ child.meta.title }}</span>
            </el-menu-item>
          </div>
        </div>
        
      </el-menu>
    </div>

    <el-button type="primary" class="exit-btn" @click="exit">
      <i class="iconfont icontuichu"></i>
      <span v-show="!isCollapse">退出登录</span>
    </el-button>
  </div>
</template>

<script>
import { menuDatas } from "@/assets/staticData/menu.js";
import { getStore } from "@/utils/localStorage";
import { mapState } from "vuex";
import { TestType } from "@/api/realTest";

export default {
  name: "Menu",
  data() {
    return {
      userInfo: JSON.parse(getStore("userInfo")),
      teacherType: ["banzhuren", "shangke", "yuejuan", "ducha"],
      isCollapse: false,
      defaultMenuIndex: [],
      menuLists: [],
      entranceType:""
    };
  },
  computed: {
    ...mapState("common", {
      studentMajor: (state) => state.studentMajor,
      // teacherRole: (state) => state.teacherRole,
      menuActive: (state) => state.menuActive,
    }),
    ...mapState("permission", [
      '_ENTRANCETYPE'
    ]),
    routes() {
      return this.$router.options.routes;
    },
  },
  watch: {
    // 教师角色切换
    // teacherRole(val) {
    //   this.getTeacherMenu(val);
    // },
    // 学生专业切换
    studentMajor(val) {
      if (val) {
        this.getExamCenter(val.profession_id);
      }
    },
    // menuLists(v){
    //   console.log(v);
    // },
  },
  mounted() {
    this.entranceType = this._ENTRANCETYPE

    this.getMenu();
  },
  methods: {
    getMenu() {
      if (this.userInfo.user_type == "student") {
        this.getStudentMenu();
      } else {
        // if (this.teacherRole) {
        //   this.getTeacherMenu(3);
        // } else {
        //   let role = "3";
        //   this.$store.commit("common/changeTeacherMutation", role);
        // }
      }
    },
    // getTeacherMenu(val) {
    //   let role = this.teacherType[Number(val) - 1];

    //   this.menuLists = menuDatas[role];

    //   this.defaultMenuIndex = menuDatas[role].map((item) => item.name);
    // },
    getStudentMenu() {
      // let role = "student";
      // let list = [...menuDatas[role]]
      // if(entranceType == 1){
      //   list.map(item => {
      //     if(item.icon == "iconshuben"){
      //       item.children.push({
      //         name: "我的课程",
      //         code: "courseList"
      //       })
      //     }
      //   })
      // }
      // let list = this.routes.filter(item => {
      //   if (item.hidden) {
      //     return false
      //   } else {
      //     return true
      //   }
      // });
      let list = this.routersHandle(this.routes);
      this.defaultMenuIndex = list.map((item) => item.meta.title);
      this.menuLists = list;
      if (this.studentMajor) {
        this.getExamCenter(this.studentMajor.profession_id);
      }
    },
    // 递归去掉hidden=true的数据
    routersHandle(list){
      let arr = [];
      for(let item of list){
        if(!item.hidden){
          arr.push(item);
          if(item.children && item.children.length > 0){
            item.children = this.routersHandle(item.children);
          }
        }
      }
      return arr;
    },
    // 动态获取练习中心菜单
    getExamCenter(profession_id) {
      TestType({ profession_id: profession_id }).then((res) => {
        if (res.code === 200) {
          for(let item of this.menuLists){
            if(item.name === 'practice'){
              let component = item.children[0].component;
              let path = item.children[0].path;
              let name = item.children[0].name;
              item.children = res.result.map((item) => {
                return {
                  path,
                  name,
                  component,
                  meta: {
                    title: item.title
                  }
                };
              });
            }
          }
          // this.menuLists[2].children =
          //   this.menuLists[2].children.concat(children);
        }
      });
    },
    // 菜单项展开收起
    menuCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // 首页
    jumpHome() {
      let name = "";
      name = "home";
      // if (this.teacherRole === "3") {
      //   //  阅卷老师
      //   name = "markingData";
      // } else if (this.teacherRole === "1") {
      //   //  班主任
      //   name = "headTeacher";
      // } else if (this.teacherRole === "2") {
      //   // 上课老师
      //   name = "attendClassTeacher";
      // } else if (this.teacherRole === "4") {
      //   //  阅卷督察
      //   name = "MarkingPapersTeacher";
      // } else {
      //   name = "home";
      // }

      this.jump({
        code: name,
      });
    },
    jump(child) {
      this.$store.commit("common/changeMenuMutation", { name: child.meta.title });
      if (child.name === "realTestStart") {
        //考前模拟
        this.$router.push({
          name: child.name,
          query: {
            type: 2,
          },
        });
        return;
      }
      this.$router.push({ name: child.name });
    },
    // 退出
    async exit() {
      // loginOut(null).then(() => {
      // this.$store.dispatch('permission/setIsGenerateRoutes', '');
      await this.$store.dispatch('permission/logOut');
      // Cookies.remove('token');
      this.$message.success('退出成功');
      this.$router.replace("/Login");

      // });
    },
  },
};
</script>

<style lang="scss">
.isShowIconArrow{
  .el-submenu__icon-arrow{
    display: none;
  }
}
.uni-menu {
  .uni-menu-list {
    &:not(.el-menu--collapse) {
      width: 250px;
    }

    &.el-menu {
      border-right: none;
    }
  }
  .el-submenu__title i {
    color: #fff;
  }
  .el-menu-item,
  .el-submenu__title {
    height: 44px;
    line-height: 44px;
  }
  .el-menu-item {
    font-size: 16px;
  }
  .el-submenu .el-menu-item {
    padding: 0 20px;
  }
  .el-menu-item:hover,
  .el-submenu__title:hover {
    @include bgColor("bg-color");
  }
}
</style>

<style lang="scss" scoped>
.el-menu--popup {
  .uni-menu-group {
    @include linearGradient("linear-gradient-start", "linear-gradient-end");
  }
}
.uni-submenu {
  color: #fff;
  padding: 10px 20px;
  border-top: 1px solid rgba($gray, 0.2);
  border-bottom: 1px solid rgba($gray, 0.2);

  .tit {
    margin-bottom: 10px;
    @extend %ellipse;
  }

  .uni-submenu-list {
    display: flex;
    flex-wrap: wrap;

    .link {
      cursor: pointer;
      display: block;
      width: 50%;
      color: #fff;
      margin-bottom: 3px;
      font-size: 13px;
      @extend %ellipse;

      &:hover {
        color: #fff !important;
      }

      span {
        display: inline-block;
        padding: 3px 5px;
        border-radius: 2px;
      }

      &.active,
      &:hover {
        & > span {
          @include bgColor("menu-hover-color");
        }
      }
    }
  }
}

.uni-menu {
  .uni-menu-box {
    height: $menuH;
    @include linearGradient-v(
      "linear-gradient-start",
      "linear-gradient-end",
      url("~@/assets/images/menu_bg.png")
    );
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;

    &::-webkit-scrollbar {
      display: none;
    }

    .iconfont {
      color: #fff;
      font-size: 19px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .icon {
      margin-right: 10px;
      height: 20px;
      width: 20px;
      display: inline-block;
      vertical-align: middle;

      &.icon3 {
        @include themeIcon("03");
      }
    }
  }

  .exit-btn {
    width: 100%;
    height: 50px;
    @include bgColor("bg-color");
    border: none;
    border-radius: 0;

    .iconfont {
      font-size: 20px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
</style>
